import { Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { AppDialogService } from 'app/shared/dialogs/dynamic-dialog.service';
import { SendElectronicInvoiceComponent } from './send-electronic-invoice.component';

@Injectable({ providedIn: 'root' })
export class SendElectronicInvoiceService {
  constructor(private appDialogService: AppDialogService) {}

  public open(data: { invoiceId: number }): DynamicDialogRef {
    this.appDialogService.layout = 'wide';
    this.appDialogService.data = data;
    return this.appDialogService.openComponent(SendElectronicInvoiceComponent);
  }
}
